<template>
	<div
		v-testid="'nav-aside'"
		:class="[$style['app-aside'], {
			[$style['app-aside--open']]: status === 'open'
		}]"
		@click="handleOffsetClose"
	>
		<aside :class="$style['app-aside__container']">
			<div :class="$style['app-aside__top']">
				<template v-if="!$breakpoints.sm">
					<BaseIconButton
						v-testid="'nav-toggle'"
						:with-ripple="false"
						:class="$style['app-aside__top-toggle']"
						@click="toggleAside"
					>
						<FontAwesomeIcon
							:icon="['fal', (status === 'open') ? 'times' : 'bars']"
							size="lg"
						/>
					</BaseIconButton>
					<div :class="$style['app-aside__top-logo']">
						<div :class="$style['app-logo']" />
					</div>
				</template>
				<AppHeaderAccount v-else />
			</div>
			<AppAsideNavigation :status="status" />
		</aside>
	</div>
</template>
<script>
import AppAsideNavigation from './AppAsideNavigation'
import AppHeaderAccount from '../AppHeader/AppHeaderAccount'
import { createNamespacedHelpers } from 'vuex'
import { TOGGLE_STATUS } from '@/store/modules/App/Aside/mutation-types'
const { mapGetters, mapMutations } = createNamespacedHelpers('App/Aside')
import breakpoints from '@/mixins/breakpoints'
export default {
	name: 'AppAside',
	components: {
		AppAsideNavigation,
		AppHeaderAccount
	},
	mixins: [breakpoints],
	computed: {
		...mapGetters({
			status: 'status'
		})
	},
	watch: {
		'$route' (_to, _from) {
			if (this.status === 'open') {
				this.toggleAside()
			}
		}
	},

	beforeDestroy () {
		document.removeEventListener('keydown', this.globalEsc)
	},

	methods: {
		...mapMutations({
			toggleStatus: TOGGLE_STATUS
		}),
		handleOffsetClose (e) {
			if (e.target === this.$el) {
				this.toggleStatus()
			}
		},
		toggleAside () {
			this.toggleStatus()

			if (this.status === 'open') {
				document.addEventListener('keydown', this.globalEsc)
			} else {
				document.removeEventListener('keydown', this.globalEsc)
			}
		},
		globalEsc (e) {
			if (e.keyCode === 27 || e.key === 'Escape') {
				this.toggleAside()
			}
		}
	}
}
</script>

<style lang="scss" module>

    .app-logo {
        background-image: url("@/assets/images/recar-logo-black.svg");
        background-repeat: no-repeat;
        background-position: center;
        height: 56px;
        width: 100px;

        @include dark-mode{
            background-image: url("@/assets/images/recar-logo-color.svg");
        }

        @include nord-mode{
            background-image: url("@/assets/images/recar-logo-color.svg");
        }
    }

    .app-aside {
        z-index: map-get($z-index, aside);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        pointer-events: none;

        &::before {
        	content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgb(0, 0, 0, .5);
			opacity: 0;
			will-change: opacity;
			transition: opacity .3s cubic-bezier(0, 0, .2, 1) 0ms;
			cursor: pointer;
        }

        &--open {
            pointer-events: auto;

            &::before {
                opacity: 1;
            }

            .app-aside__container {
                transform: none;
                transition-duration: 250ms;
                width: calc(100% - #{map-deep-get($header, height, lg)});

                @include media-breakpoint-up(lg) {
                    width: 290px;
                }
            }
        }

        &__container {
            height: 100%;
			background-color: getColor(surface);
			border: 0;
            position: absolute;
            right: auto;
            left: 0;
            display: flex;
            flex-direction: column;
            width: calc(100% - 56px);
            max-width: 290px;
            overflow: hidden;
            touch-action: none;
            transform: translateX(calc(-100% - 20px));
			will-change: transform;
            box-shadow: 0 0 18px 0 rgb(0, 0, 0, 0.2);
            pointer-events: auto;
            transition-timing-function: cubic-bezier(.4,0,.2,1);
            transition-property: width, transform;
            transition-duration: 200ms;

			@include dark-mode {
				border-right: 1px solid getColor(border);
			}

            @include media-breakpoint-up(lg) {
                // width: calc(100% - #{map-deep-get($header, height, lg)});
                transform: none;
                width: map-deep-get($header, height, lg);
            }
        }

        &__top {
            display: flex;
            height: map-deep-get($header, height, lg);
            // max-height: ;
            padding: $gutter $gutter * 2;
            margin-bottom: $gutter;
            align-items: center;

            @include media-breakpoint-down(sm) {
                padding: 0;
                height: 56px;
                min-height: 56px;
            }

            &-logo {
                flex: 1;
                display: flex;
                align-items: center;
                height: 64px;

                img {
                    max-width: 100px;
                    height: 100%;
                }
            }

            &-toggle {
                margin-right: $gutter * 1.25 !important;
            }
        }
    }
</style>
